import {
  Component,
  OnInit,
  ViewChild,
  NgZone,
  OnDestroy,
  PLATFORM_ID,
  Inject,
} from '@angular/core';
import { FormGroup, FormControl, Validators } from '@angular/forms';
import { MatDialog } from '@angular/material/dialog';
import { ActivatedRoute, Router } from '@angular/router';
import { interval } from 'rxjs';
import { takeWhile } from 'rxjs/operators';
import { AuthenticateService } from 'src/app/modules/authenticate/services/authenticate.service';
import { PanelService } from 'src/app/modules/shared/services/api/panel.service';
import { ProfileResolverService } from 'src/app/modules/shared/services/resolver/profile-resolver.service';
import { StoreDetailService } from 'src/app/modules/shared/services/resolver/store-detail.service';
import { SnackBarService } from 'src/app/modules/shared/services/snack-bar.service';
import {
  RecaptchaVerifier,
  getAuth,
  signInWithPhoneNumber,
} from '@firebase/auth';
import { initializeApp } from 'firebase/app';
import { WindowService } from '../../../authenticate/services/window.service';
import { GoogleAuthProvider, signInWithPopup } from 'firebase/auth';
import { GoogleTagManagerService } from 'src/app/modules/shared/services/google-tag-manager.service';
import { DynamicScript } from 'src/app/modules/shared/services/dynamic-script.service';
import { isPlatformBrowser } from '@angular/common';
import { environment } from 'src/environments/environment';
import { parsePhoneNumberFromString } from 'libphonenumber-js';
import { CountryDetail } from 'src/app/modules/shared/models/profile.mode';
import { DeviceDetectorService } from 'src/app/modules/shared/services/device-detector/device-detector.service';
import { LogoutDialogComponent } from '../logout-dialog/logout-dialog.component';
import { FACEBOOK_EVENT_TYPES } from 'src/app/modules/shared/services/meta-pixel/meta-pixel.model';
import { MetaPixelService } from 'src/app/modules/shared/services/meta-pixel/meta-pixel.service';

declare const AppleID: any;

@Component({
  selector: 'app-edit-profile',
  templateUrl: './edit-profile.component.html',
  styleUrls: ['./edit-profile.component.scss'],
})
export class EditProfileComponent implements OnInit, OnDestroy {
  editForm: FormGroup;
  userProfile: any;
  today = new Date().toISOString().split('T')[0];
  verificationField = new FormControl('', [Validators.required]);
  remainingTime = {
    timer: 120000,
    seconds: '00',
    minutes: '02',
  };
  storeDetail: any;
  dialogRef: any;
  @ViewChild('VerifyPhoneNumber') VerifyPhoneNumber: any;
  @ViewChild('VerifyCode') VerifyCode: any;
  @ViewChild('editPhoneNumberDialog') editPhoneNumberDialog: any;
  windowRef: any;
  recaptchaChecked: boolean = false;
  isVerify: boolean = false;
  buyingProductId;
  buyingProductName;
  subscriptions = [];
  isEditMode: boolean = false;
  editPhoneNumberActiveTab: number = 1;
  isAppleConnected: boolean = false;
  isGoogleConnected: boolean = false;
  countryList: CountryDetail[];
  userCountryDetail: any;

  genderList = [
    {
      gender: 'Male',
      value: 1,
    },
    {
      gender: 'Female',
      value: 2,
    },
    {
      gender: 'Other',
      value: 3,
    },
  ];

  logoFile: any;
  kycIsDisabled: boolean = false;
  platformId: any;
  isDesktop: boolean = false;
  constructor(
    private profileResolver: ProfileResolverService,
    private panelService: PanelService,
    private router: Router,
    private snackBarService: SnackBarService,
    private authenticateService: AuthenticateService,
    private dialog: MatDialog,
    private activatedRoute: ActivatedRoute,
    private storeDetailResolver: StoreDetailService,
    private win: WindowService,
    private zone: NgZone,
    private googleTagManagerService: GoogleTagManagerService,
    private loadScript: DynamicScript,
    private deviceDetectorService: DeviceDetectorService,
    private metaPixelService: MetaPixelService,
    @Inject(PLATFORM_ID) platFormId: Object
  ) {
    this.platformId = platFormId;
    this.isDesktop = this.deviceDetectorService.isDesktop;
    this.activatedRoute.params.subscribe((params) => {
      this.router.routeReuseStrategy.shouldReuseRoute = () => false;
    });
  }

  ngOnInit(): void {
    this.getStoreDetail();
    this.profileResolver.permissionInitInfo.subscribe((data) => {
      this.userProfile = data;
    });
    this.initForm();
    this.getCountries();
    !this.userProfile.email && this.initGoogleRecaptcha();
    this.loadAppleAuth();
    this.checkAccessParam();
  }

  ngOnDestroy() {
    document.removeEventListener(
      'AppleIDSignInOnSuccess',
      this.appleSuccessConnect
    );
    document.removeEventListener(
      'AppleIDSignInOnFailure',
      this.appleErrorConnect
    );

    this.subscriptions.forEach((subscription) => {
      subscription.unsubscribe();
    });
  }

  getStoreDetail() {
    this.storeDetail = this.storeDetailResolver.permissionInit;
    initializeApp(this.storeDetail.firebase_config);
  }

  initForm() {
    this.editForm = new FormGroup({
      first_name: new FormControl(
        this.userProfile?.first_name,
        Validators.required
      ),
      email: new FormControl({
        value: this.userProfile?.email,
        disabled: true,
      }),
      phone: new FormControl({
        value: this.userProfile?.phone_number
          ? `+${this.userProfile?.phone_number}`
          : '',
        disabled: true,
      }),
      birthdate: new FormControl(this.userProfile?.birthdate),
      gender: new FormControl(this.userProfile?.gender),
    });
  }

  startTimer() {
    this.remainingTime = {
      timer: 120000,
      seconds: '00',
      minutes: '02',
    };
    const source = interval(1000);
    const remainTimer = source
      .pipe(takeWhile((val) => this.unsubscribeTimer()))
      .subscribe((val) => {
        let seconds = this.remainingTime.timer / 1000;
        let minutes = parseInt(`${seconds / 60}`);
        seconds = parseInt(`${seconds % 60}`);
        this.remainingTime.seconds =
          seconds < 10 ? '0' + seconds : `${seconds}`;
        this.remainingTime.minutes =
          minutes < 10 ? '0' + minutes : `${minutes}`;
        this.remainingTime.timer -= 1000;
      });
  }

  unsubscribeTimer() {
    return this.remainingTime.timer < 1 ? false : true;
  }

  onSubmitPhone() {
    if (this.editForm.controls.phone.invalid) {
      return;
    }

    const appVerifier = this.windowRef.recaptchaVerifier;
    const num = this.editForm.controls.phone.value;
    const auth = getAuth();
    signInWithPhoneNumber(auth, num, appVerifier)
      .then((result) => {
        this.windowRef.confirmationResult = result;
        this.verificationField.setValue('');
        this.dialogRef = this.dialog.open(this.VerifyCode);
        this.startTimer();
      })
      .catch((error) => {
        this.snackBarService.showSnackBar(error, 'primary', 2000);
      });
  }

  onSubmitVerification() {
    if (
      this.editForm.controls.phone.invalid ||
      this.verificationField.invalid
    ) {
      return;
    }

    this.windowRef.confirmationResult
      .confirm(this.verificationField.value)
      .then((result: any) => {
        this.firebaseValidateToken(result._tokenResponse.idToken);
      })
      .catch((error) => {
        this.snackBarService.showSnackBar(error, 'primary', 2000);
      });
  }

  firebaseValidateToken(token: any) {
    this.authenticateService.firebaseValidateToken({ token }).subscribe(
      (res) => {
        this.profileResolver.updateInfo().then(() => {
          this.profileResolver.permissionInitInfo.subscribe((data) => {
            this.userProfile = data;
          });
          this.onSubmit();
        });
        this.dialogRef.close();
      },
      (error) => {
        this.snackBarService.showSnackBar(error.error.detail, 'primary', 2000);
      }
    );
  }

  resendCode() {
    this.verificationField.setValue('');
    this.dialogRef.close();
    this.onSubmit();
  }

  reinitRecaptcha() {
    const auth = getAuth();
    this.windowRef.recaptchaVerifier = new RecaptchaVerifier(
      'recaptcha-resend',
      {
        callback: () => {
          this.onSubmitPhone();
        },
      },
      auth
    );
    this.windowRef.recaptchaVerifier.render();
  }

  onSubmit() {
    if (this.editForm.invalid) {
      return;
    }
    let changedForm = this.getChangedEditForm();
    if (Object.keys(changedForm).length == 0) {
      return;
    }

    const data = new FormData();
    for (let key in changedForm) {
      if (key == 'birthdate' && changedForm[key].value > this.today) {
        this.snackBarService.showSnackBar(
          'birthday can not be in the future.',
          'primary',
          4000
        );
        return;
      }

      data.append(key, changedForm[key].value.toString());
    }

    this.panelService.editProfile(data).subscribe(
      (res) => {
        this.userProfile = res;
        this.profileResolver.updateInfo();
        this.editForm.patchValue({
          first_name: this.userProfile?.first_name,
        });
        this.initForm();
        this.logoFile = '';
        this.snackBarService.showSnackBar(
          'Profile edited successfully.',
          'primary',
          2000
        );

        if (this.isDesktop) {
          this.isEditMode = false;
          this.router.navigate(['/profile'], { queryParams: { tab: 'edit' } });
        } else {
          this.router.navigate(['/profile']);
        }

        if (this.buyingProductId) {
          let title = this.buyingProductName.replace(/[^a-zA-Z0-9]+/g, '-');
          this.zone.run(() => {
            this.router.navigate([`/product/${this.buyingProductId}/${title}`]);
          });
        } else {

        }
      },
      (error) => {
        this.snackBarService.showSnackBar(error.error.detail, 'primary', 2000);
      }
    );
  }

  getCountries() {
    this.panelService.getCountryList({ ordering: 'name' }).subscribe((data) => {
      this.countryList = data;
      this.checkUserPhoneCountry();
    });
  }

  getChangedEditForm() {
    let controls = this.editForm.controls;
    let changedValue = {};
    for (let key in controls) {
      if (controls[key].dirty) {
        changedValue[key] = controls[key];
      }
    }
    return changedValue;
  }

  loginGoogleFirebase() {
    const provider = new GoogleAuthProvider();
    provider.setCustomParameters({
      prompt: 'select_account',
    });
    const auth = getAuth();
    signInWithPopup(auth, provider)
      .then((result: any) => {
        const credential = GoogleAuthProvider.credentialFromResult(result);
        const idToken = result._tokenResponse.idToken;
        this.connectWithGoogle(idToken);
        const user = result.user;
      })
      .catch((error) => {
        const errorMessage = error.message;
        this.snackBarService.showSnackBar(errorMessage, 'primary', 2000);
      });
  }

  connectWithGoogle(token) {
    this.authenticateService.firebaseConnect({ token }).subscribe((res) => {
      this.googleTagManagerService.sendAnalytics('login', { method: 'Google' });
      this.googleTagManagerService.sendAnalytics('conversion_event_signup', {
        method: 'Google',
      });
      this.metaPixelService.pushEvent(
        FACEBOOK_EVENT_TYPES.COMPLETE_REGISTRATION,
        {
          data: {
            currency: 'Google',
            value: 1,
          },
        }
      );
      this.profileResolver.updateInfo();
      this.isGoogleConnected = true;
      this.isEditMode = false;
    });
  }

  loadAppleAuth() {
    this.loadScript.loadAppleScript().then(() => {
      let redirectURI;
      if (this.isClientPlatform(this.platformId)) {
        redirectURI = window.location.origin;
      }

      AppleID.auth.init({
        clientId: environment.appleClientId,
        scope: 'name email',
        redirectURI: redirectURI,
        state: '',
        usePopup: true,
      });
    });

    document.addEventListener(
      'AppleIDSignInOnSuccess',
      this.appleSuccessConnect
    );
    document.addEventListener('AppleIDSignInOnFailure', this.appleErrorConnect);
  }

  appleSuccessConnect = (data) => {
    if ((<any>data).detail?.authorization?.id_token) {
      this.connectToApple((<any>data).detail?.authorization?.id_token);
    }
  };

  appleErrorConnect = (error) => {
    this.snackBarService.showSnackBar(
      (<any>error).detail?.error,
      'primary',
      2000
    );
  };

  connectToApple(token) {
    this.panelService.appleConnect({ token }).subscribe((res) => {
      this.profileResolver.updateInfo();
      this.isAppleConnected = true;
      this.isEditMode = false;
    });
  }

  checkAccessParam() {
    const routeParam = this.activatedRoute.queryParams.subscribe((params) => {
      if (params.product && params.name) {
        this.buyingProductId = params.product;
        this.buyingProductName = params.name;
      } else {
        this.buyingProductId = '';
        this.buyingProductName = '';
      }
    });
    this.subscriptions.push(routeParam);
  }

  onBack() {
    console.log(this.isEditMode);
    if (this.isEditMode) {
      this.isEditMode = false;
    } else {
      this.router.navigate(['/profile']);
    }
  }

  clearInputField(controlName: string) {
    this.editForm.get(controlName).reset();
  }

  onEditPhoneNumber() {
    let dialogRef = this.dialog.open(this.editPhoneNumberDialog, {
      height: '430px',
      width: '592px',
      panelClass: 'edit-phone-dialog',
    });
  }

  initGoogleRecaptcha() {
    this.windowRef = this.win.windowRef;
    const auth = getAuth();
    this.windowRef.recaptchaVerifier = new RecaptchaVerifier(
      'recaptcha-wrapper',
      {
        callback: () => {
          this.recaptchaChecked = true;
        },
        'expired-callback': () => {
          this.recaptchaChecked = false;
        },
      },
      auth
    );
    this.windowRef.recaptchaVerifier.render();
  }

  setEditPhoneActiveTab(selectedType: any) {
    this.editPhoneNumberActiveTab = selectedType;
  }

  closeDialogs() {
    this.dialog.closeAll();
  }

  isClientPlatform(platformId: Object) {
    if (isPlatformBrowser(platformId)) {
      return true;
    } else return false;
  }

  checkUserPhoneCountry() {
    if (!this.userProfile?.phone_number) return;

    const phoneNumber = parsePhoneNumberFromString(
      `+${this.userProfile.phone_number}`
    );
    this.userCountryDetail = this.countryList.find(
      (country) => country.code == phoneNumber.country
    );
  }

  logOut() {
    this.dialog.open(LogoutDialogComponent, {
      width: '350px',
      height: '200px',
      panelClass: 'logout-dialog',
    });
  }
}
